import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutUser } from "../state/slices/userSlice";
import FacebookIcon from "../icons/FacebookIcon";
import InstagramIcon from "../icons/InstagramIcon";
import { Button } from "antd";
import CancelReservationModal from "../modals/CancelReservationModal";
import { getRole, isLoggedIn } from "../services/auth.service";

export default function Navbar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userRole = getRole();
  const isUserLoggedIn = isLoggedIn();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logoutUser());
    sessionStorage.removeItem("token");
    navigate("/login");
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancelModal = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = (values) => {
    debugger;
    console.log("Form Values:", values);
    setIsModalOpen(false); // Close modal after form submission
  };

  return (
    <>
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-cover bg-center z-40"
          style={{ backgroundImage: "url('/images/modalbackground.png')" }}
        ></div>
      )}
      <nav className="bg-white py-1 flex items-center shadow-md">
        <div className="flex items-center" onClick={() => navigate("/")}>
          <img
            src={"/images/igraonicelogo.png"}
            alt="Logo"
            className="h-14 w-auto px-6" // Tailwind: height 8 for a smaller logo
          />
        </div>
        {/* <span className="text-2xl text-white font-bold cursor-pointer">
                IgraoniceBL
            </span> */}
        <div className="overflow-x-auto">
          <ul className="flex space-x-6 pl-8 whitespace-nowrap">
            {isUserLoggedIn && (
              <li className="nav-item">
                <span
                  className="text-lg text-footerBlue font-bold cursor-pointer"
                  onClick={() => navigate("/reservations")}
                >
                  Rezervacije
                </span>
              </li>
            )}
            {isUserLoggedIn && userRole === "SuperAdmin" && (
              <li className="nav-item">
                <span
                  className="text-lg text-footerBlue font-bold cursor-pointer"
                  onClick={() => navigate("/playrooms")}
                >
                  Igraonice
                </span>
              </li>
            )}
            {isUserLoggedIn && userRole === "SuperAdmin" && (
              <li className="nav-item">
                <span
                  className="text-lg text-footerBlue font-bold cursor-pointer"
                  onClick={() => navigate("/accounts")}
                >
                  Korisnici
                </span>
              </li>
            )}
            {isUserLoggedIn && (
              <li className="nav-item">
                <span
                  className="text-lg text-footerBlue font-bold cursor-pointer"
                  onClick={handleLogout}
                >
                  Odjava
                </span>
              </li>
            )}
          </ul>
        </div>

        {/* Right side: Otkazi button and social media icons (visible on large screens) */}
        <div className="hidden md:flex items-center space-x-4 pr-6 ml-auto">
          <Button
            type="submit"
            onClick={() => {
              showModal();
              setIsMenuOpen(false); // Close menu after navigation
            }}
            className="bg-cancelReservationBlue text-white rounded-[30px] px-4 h-10 w-full text-left font-semibold"
          >
            OTKAŽI REZERVACIJU
          </Button>
          <a
            href="https://www.facebook.com/share/9TUPPWTqfzBgLMP2/?mibextid=LQQJ4d"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FacebookIcon className="h-6 w-6 text-footerBlue cursor-pointer" />
          </a>
          <a
            href="https://www.instagram.com/igraonicebl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon className="h-6 w-6 text-footerBlue cursor-pointer" />
          </a>
        </div>

        {/* Mobile Menu: hamburger icon */}
        <div className="md:hidden flex items-center pr-6 ml-auto">
          <button
            onClick={toggleMenu}
            className="text-footerBlue font-extrabold text-3xl focus:outline-none"
          >
            ☰
          </button>
        </div>

        {/* Mobile dropdown menu */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-14 right-6 bg-white shadow-lg rounded-lg py-4 px-6 z-50">
            <ul className="space-y-4">
              <li>
                <Button
                  type="submit"
                  onClick={() => {
                    showModal();
                    setIsMenuOpen(false); // Close menu after navigation
                  }}
                  className="bg-cancelReservationBlue text-white rounded-[30px] px-4 h-10 w-full text-left font-semibold"
                >
                  OTKAŽI REZERVACIJU
                </Button>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/share/9TUPPWTqfzBgLMP2/?mibextid=LQQJ4d"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="flex items-center space-x-2">
                    <FacebookIcon className="h-6 w-6 text-cancelReservationBlue cursor-pointer" />
                    <span className="text-cancelReservationBlue text-lg font-semibold">
                      facebook
                    </span>
                  </div>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/igraonicebl"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="flex items-center space-x-2">
                    <InstagramIcon className="h-6 w-6 text-cancelReservationBlue cursor-pointer" />
                    <span className="text-cancelReservationBlue text-lg font-semibold">
                      instagram
                    </span>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        )}

        <CancelReservationModal
          isModalOpen={isModalOpen}
          handleCancelModal={handleCancelModal}
          handleFormSubmit={handleFormSubmit}
        />
      </nav>
    </>
  );
}
